import React from "react";
import { MessageCircle } from "lucide-react";
import { wa } from "@/lib/brand";

const FloatingWhatsApp = () => (
  <a
    href={wa()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Chat with GN Agro Traders on WhatsApp"
    className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50 inline-flex items-center justify-center h-12 w-12 md:h-14 md:w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:scale-105 transition-transform"
  >
    <MessageCircle className="h-6 w-6" />
  </a>
);

export default FloatingWhatsApp;
